import React from 'react'
import { Inss } from './Inss'
import { Servidores } from './Servidores'
import { Default } from './Default'
import { Matricula } from 'models/atendimento/types'
import { CardBeneficio } from './style'
import { BolsaFamilia } from './BolsaFamilia'

interface BeneficiosTabsProps {
  index: number
  matricula?: Matricula
}

const BeneficiosTabs = ({ matricula, index }: BeneficiosTabsProps) => {
  switch (matricula?.tipoPerfil) {
    case 0:
      return (
        <CardBeneficio className="my-2">
          <div className="container-fluid">
            <label className="label-12">{matricula?.descricaoPerfil}</label>
            <BolsaFamilia index={index} />
          </div>
        </CardBeneficio>
      )
    case 1:
      return (
        <CardBeneficio className="my-2">
          <div className="container-fluid">
            <label className="label-12">{matricula?.descricaoPerfil}</label>
            <Inss index={index} />
          </div>
        </CardBeneficio>
      )
    case 4:
      return (
        <CardBeneficio className="my-2">
          <div className="container-fluid">
            <label className="label-12">{matricula?.descricaoPerfil}</label>
            <Servidores index={index} />
          </div>
        </CardBeneficio>
      )
    case 3:
      return (
        <CardBeneficio className="my-2">
          <div className="container-fluid">
            <label className="label-12">{matricula?.descricaoPerfil}</label>
            <Servidores index={index} />
          </div>
        </CardBeneficio>
      )
    case 5:
      return (
        <CardBeneficio className="my-2">
          <div className="container-fluid">
            <label className="label-12">{matricula?.descricaoPerfil}</label>
            <Servidores index={index} />
          </div>
        </CardBeneficio>
      )
    default:
      return (
        <CardBeneficio className="my-2">
          <div className="container-fluid">
            <label className="label-12">{matricula?.descricaoPerfil}</label>
            <Default index={index} />
          </div>
        </CardBeneficio>
      )
  }
}

export default BeneficiosTabs
